import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    avatar: {
        background: theme.palette.neutral[200],
        cursor: 'pointer',
        // border: `3px solid ${theme.palette.utility.neutralv5[50]}`,
        color: theme.palette.text.primary,
        height: theme.spacing(6),
        width: theme.spacing(6),
    },
    dropDownOption: {
        padding: '8px',
        cursor: 'pointer',
        fontSize: '16px',

        '&:hover': {
            color: theme.palette.secondary.main,
        },
    },
    globalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(3, 4),
        boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.35)',
        borderRadius: theme.dimensions.borderRadiusPanel,
        height: '100%',
        color: theme.palette.text.primary,
    },
    globalHeaderWrapper: {
        zIndex: 1,
        height: theme.spacing(9),
        margin: theme.spacing(3, 4),
        background: theme.palette.neutral[50],
        backgroundPosition: 'calc(100% - 60px) 2px',
        backgroundRepeat: 'no-repeat',
        borderRadius: '5px',
    },
    globalHeader__burgerMenu: {
        cursor: 'pointer',
        height: theme.spacing(3),
        width: theme.spacing(3),
        '& svg': {
            height: '100%',
            width: '100%',
        },
        [theme.breakpoints.up(theme.breakpoints.values.md)]: {
            display: 'none',
        },
        [theme.breakpoints.down(theme.breakpoints.values.md)]: {
            display: 'block',
        },
    },
    globalHeader__greeting: {
        fontSize: '20px',
        lineHeight: '26px',
        textAlign: 'center',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        maxWidth: '500px',
        whiteSpace: 'nowrap',
    },
    globalHeader__logoLink: {
        display: 'flex',
    },
    globalHeader__logo: {
        width: '100px',
    },
    globalHeader__menuWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(3),
    },
    languageSwitcher: {
        width: '100%',
        padding: theme.spacing(0, 2),
        paddingBottom: theme.spacing(1),

        '& .MuiInput-root': {
            background: theme.palette.background.neutral,
            padding: theme.spacing(1, 2),
            fontSize: theme.typography.size.m,
            height: theme.spacing(4),
            borderRadius: '5px',
        },
        '& .MuiInput-underline:before': {
            borderRadius: '5px',
        },
    },
    item: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        backgroundColor: 'transparent',
        '&:hover': {
            color: theme.palette.secondary.main,
            backgroundColor: 'transparent',
        },
    },
    item__version: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        backgroundColor: theme.palette.background.default,
        userSelect: 'text',
        fontSize: theme.typography.size.m,
        padding: '6px 16px',

        '&:hover': {
            backgroundColor: `${theme.palette.background.default} !important`,
        },
    },
    lh1: {
        lineHeight: 1,
    },
    menu__chevron: {
        height: theme.spacing(3),
        fontSize: '24px',
        cursor: 'pointer',
    },
    menu__wrapper: {
        background: theme.palette.background.default,
        padding: theme.spacing(2, 0),
        width: '236px',
    },
    menu__personalSettings: {
        color: 'red',
    },
    menuItems: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,

        '&:hover': {
            backgroundColor: theme.palette.background.default,
        },
    },
    menuItems__version: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,
        cursor: 'default',
    },
    menu_link_wrapper: {
        display: 'flex',
        gap: theme.spacing(1),
    },
    notifWrapper: {
        cursor: 'pointer',
    },
    themeToggleHeadline: {
        fontSize: theme.typography.size.m,
        marginTop: theme.spacing(1),
    },
    tooltip: {
        background: theme.palette.neutral[100],
        color: theme.palette.text.primary,
        borderRadius: theme.dimensions.borderRadiusInput,
        opacity: 1,
        padding: theme.spacing(0.5, 1),
        fontSize: theme.typography.size.s,
    },
    roleSwitcher: {
        width: '100%',
        padding: theme.spacing(1, 2),

        '& .MuiInput-underline:before': {
            borderRadius: '5px',
        },
        '& .MuiInput-root': {
            background: theme.palette.background.neutral,
            padding: theme.spacing(1, 2),
            borderRadius: '5px',
            height: theme.spacing(4),

            '& .MuiSelect-icon': {
                top: 'auto',
            },
        },
    },
}));
